import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { slideTransition } from "./animations/slide-transition";

import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GoogleMapsModule } from "@angular/google-maps";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { CodeInputModule } from "angular-code-input";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { JwtInterceptor } from "./helpers/jwt.interceptor";
import { AuthErrorInterceptor } from "./interceptors/auth-error.interceptor";

import { File } from "@awesome-cordova-plugins/file/ngx";
import { LocationAccuracy } from "@awesome-cordova-plugins/location-accuracy/ngx";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { LoginPage } from "./pages/auth/login/login.page";
import { EmailForgotPasswordPage } from "./pages/auth/register/forgot-password/email-forgot-password/email-forgot-password.page";
import { ForgotPasswordPage } from "./pages/auth/register/forgot-password/forgot-password.page";
import { RegisterPage } from "./pages/auth/register/register.page";
import { FirstStepPage } from "./pages/auth/register/steps/first-step/first-step.page";
import { SecondStepPage } from "./pages/auth/register/steps/second-step/second-step.page";
import { VerifyCodePage } from "./pages/auth/register/verify-code/verify-code.page";
import { HomePage } from "./pages/home/home.page";
import { NetworkErrorComponent } from "./pages/network-error/network-error.component";
import { IosKeyboardScrollDirective } from "./shared/directives/ios-keyboard-scroll.directive";

import { SplashComponent } from "./pages/splash/splash.component";
import { FooterTabsComponent } from "./shared/footer-tabs/footer-tabs.component";
import { ImageFieldComponent } from "./shared/form-components/image-field/image-field.component";
import { SharedModule } from "./shared/shared.module";
import { FirebaseAuthService } from "./_services/firebase/firebase-auth.service";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export function webGoogleRedirectBootstrapFactory(
  firebaseAuth: FirebaseAuthService
) {
  return () => firebaseAuth.captureWebGoogleRedirectOnBootstrap();
}

@NgModule({
  declarations: [
    AppComponent,
    HomePage,
    LoginPage,
    RegisterPage,
    VerifyCodePage,
    FirstStepPage,
    SecondStepPage,
    ForgotPasswordPage,
    FooterTabsComponent,
    EmailForgotPasswordPage,
    SplashComponent,
    NetworkErrorComponent,
    IosKeyboardScrollDirective,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      swipeBackEnabled: false,
      navAnimation: slideTransition,
      scrollAssist: true,
      scrollPadding: true,
    }),
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    GoogleMapsModule,
    CodeInputModule,
    BrowserAnimationsModule,
    FormsModule,
    SharedModule,
    SlickCarouselModule,
    ImageFieldComponent,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      isolate: false,
    }),
  ],

  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: webGoogleRedirectBootstrapFactory,
      deps: [FirebaseAuthService],
      multi: true,
    },
    LocationAccuracy,
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true },
    File,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
